import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Audit } from '../../models/audit';
import { environment } from '../../environments/environment';
const CLOUD_FUNC_URL = environment.cloudUrl;
/*
  Generated class for the AuditScheduleProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuditScheduleProvider {
  
  auditScheduleDraft:Audit;
  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events,private http: HttpClient) {
    console.log('Hello AuditScheduleProvider Provider');
  }


  intializeSubscriptions(){

  	this.events.subscribe('audit:getScheduleDraft', (audit:Audit) => {

        this.getScheduleDraft();

    });

  	this.events.subscribe('audit:updateScheduleDraft', (audit:Audit) => {

        this.updateScheduleDraft(audit);

    });

    this.events.subscribe('audit:getAuditTypes', () => {

        this.getAuditTypes();

    });

    this.events.subscribe('audit:getSectionsList', (typeId:string) => {

        this.getSectionsList(typeId);

    });

     this.events.subscribe('audit:getApproversList', (typeId:string) => {

        this.getApproversList(typeId);

      });

      this.events.subscribe('audit:getSignaturesList', (typeId:string) => {

        this.getSignaturesList(typeId);

      });


    this.events.subscribe('audit:getSectionQuestions', (typeId:string,sectionId:string) => {

        this.getSectionQuestions(typeId,sectionId);

     });
    this.events.subscribe('audit:schedule', (audit:any) => {

        this.scheduleAudit(audit);

    });

    this.events.subscribe('audit:reschedule', (audit:any) => {

        this.rescheduleAudit(audit);

    });

    this.events.subscribe('audit:getLastAudit', (auditTypeId:string,dealerId:string,isReschedule:boolean) => {

        this.getLastAudit(auditTypeId,dealerId,isReschedule);

    });

    this.events.subscribe('audit:inviteDealer', (audit:any) => {

        this.inviteDealer(audit);

    });

    this.events.subscribe('audit:getApproverUsersList', () => {

        this.getApproverUsersList();

      });

    



  }

  removeSubscriptions(){
  	this.events.unsubscribe('audit:getScheduleDraft');
  	this.events.unsubscribe('audit:updateScheduleDraft');
    this.events.unsubscribe('audit:getAuditTypes');
    this.events.unsubscribe('audit:getSectionsList');
    this.events.unsubscribe('audit:schedule');
    this.events.unsubscribe('audit:inviteDealer');
    this.events.unsubscribe('audit:reschedule');
    this.events.unsubscribe('audit:getLastAudit');
    this.events.unsubscribe('audit:getApproversList');
    this.events.unsubscribe('audit:getSignaturesList');
    this.events.unsubscribe('audit:getApproverUsersList');
  }

  async getScheduleDraft(){
  	const scheduleDraft = await this.storage.get('auditScheduleDraft');
  	this.events.publish('audit:scheduleDraft',scheduleDraft);
  }

  async updateScheduleDraft(audit:Audit){
  	await this.storage.set('auditScheduleDraft', audit);
  }

  async deleteScheduleDraft(){
    await this.storage.remove('auditScheduleDraft');
  }

  async getAuditTypes(){
  	const auditTypes = await this.afs.collection('audtypes',ref => ref.where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    const name = data.name ? data.name : '';
                    const description = data.description ? data.description : '';
                    const image = data.image ? data.image : '';
                    const duration = data.duration ? data.duration : '';
                    return { id, name, description, image, duration };
    }))).pipe(first()).toPromise();
    this.events.publish('audit:audtypes',auditTypes);
  }

  async getSectionsList(typeId:string){
     const auditTypeSections = await this.afs.collection('audtypes').doc(typeId).collection('sections',ref => ref.orderBy('order').where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
    }))).pipe(first()).toPromise();
    this.events.publish('audit:sectionsList',auditTypeSections);
  }

   async getApproversList(typeId:string){
     let auditTypeApprovers = await this.afs.collection('audtypes').doc(typeId).collection('approvers',ref => ref.where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                   
                    return data;
    }))).pipe(first()).toPromise();

    auditTypeApprovers.forEach(async (approver,index) => {
       if(approver.aid){
                let user = await this.afs.collection('users').doc(approver.aid).valueChanges().pipe(first()).toPromise();
                auditTypeApprovers[index]['name'] = user['name'];
           }
    });
    this.events.publish('audit:approvers',auditTypeApprovers);
  }

  async getSignaturesList(typeId:string){
      const auditTypeSignatures = await this.afs.collection('audtypes').doc(typeId).collection('signatures',ref => ref.where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                   
                    return data ;
    }))).pipe(first()).toPromise();
    this.events.publish('audit:signatures',auditTypeSignatures);
  }

  async getSectionQuestions(typeId:string,sectionId:string){
     const auditSectionQuestions = await this.afs.collection('audtypes').doc(typeId).collection('sections').doc(sectionId).collection('questions',ref => ref.orderBy('order').where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
    }))).pipe(first()).toPromise();
    this.events.publish('audit:sectionQuestions',auditSectionQuestions,sectionId);
  }

  async getApproverUsersList(){
     
     let approvers = await this.afs.collection('users',ref => ref.where('roles','array-contains',"approver")).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    data['id'] = id;
                    return { id, ...data };
    }))).pipe(first()).toPromise();

    console.log("apprs:",approvers);
     this.events.publish('audit:approverUsersList',approvers);
  }


  async scheduleAudit(audit){
    let sections:any;
      sections = audit.sections;
      console.log('sections', sections)
      // const timeline = audit.timeline;
      delete audit['sections'];
      // delete audit['timeline'];
      try {
        const auditDoc = await this.afs.collection('audits').add(audit);
        console.log(auditDoc);
        if(auditDoc && auditDoc.id){
      
          const auditId = auditDoc.id;
          if(sections && sections.length > 0){

            await Promise.all(sections.map(async (section) => {
                const questions = section.questions;
                
                delete section['questions'];
                
                 await this.afs.collection('audits').doc(auditId).collection('sections').doc(section.id).set(section);
                 if(questions && questions.length > 0){
                      await Promise.all(questions.map(async (question) => {
                        await this.afs.collection('audits').doc(auditId).collection('sections').doc(section.id).collection('questions').doc(question.id).set(question);
                      }));

                 }
            }));
          }

           this.events.publish('audit:scheduleSuccess',auditId);
           this.deleteScheduleDraft();
        }
        else{
          this.events.publish('audit:scheduleFailure');
        }
        
      }
      catch(err) {
        console.log("inside catch");
        console.log(err);
        this.events.publish('audit:scheduleFailure');
      }

  }

  async rescheduleAudit(audit){

    console.log(audit);
    try {
     if(audit.id){
        const auditSections = await this.afs.collection('audits').doc(audit.id).collection('sections',ref => ref.orderBy('order')).snapshotChanges().pipe(
                      map(actions => actions.map(a => {
                        const data = a.payload.doc.data() as any;
                        const id = a.payload.doc.id;
                        return { id, ...data };
        }))).pipe(first()).toPromise();

        if(auditSections){
            auditSections.forEach(async(section) => {
                 const sectionQues = await this.afs.collection('audits').doc(audit.id).collection('sections').doc(section.id).collection('questions').snapshotChanges().pipe(
                      map(actions => actions.map(a => {
                        const data = a.payload.doc.data() as any;
                        const id = a.payload.doc.id;
                        return { id, ...data };
                  }))).pipe(first()).toPromise();

                 sectionQues.forEach(async(que) => {
                   await this.afs.collection('audits').doc(audit.id).collection('sections').doc(section.id).collection('questions').doc(que.id).delete();
                 });


                 await this.afs.collection('audits').doc(audit.id).collection('sections').doc(section.id).delete();
            });
        }
        const sections = audit.sections;
       
          delete audit['sections'];
          await this.afs.collection('audits').doc(audit.id).update(audit);

          if(sections && sections.length > 0){

                await Promise.all(sections.map(async (section) => {
                    const questions = section.questions;
                    
                    delete section['questions'];
                    
                     await this.afs.collection('audits').doc(audit.id).collection('sections').doc(section.id).set(section);
                     if(questions && questions.length > 0){
                          await Promise.all(questions.map(async (question) => {
                            await this.afs.collection('audits').doc(audit.id).collection('sections').doc(section.id).collection('questions').doc(question.id).set(question);
                          }));

                     }
                }));

        }
        this.events.publish('audit:scheduleSuccess',audit.id);
      }
      else{
        this.events.publish('audit:scheduleFailure');
      }
   }
   catch(err) {
        console.log("inside catch");
        console.log(err);
        this.events.publish('audit:scheduleFailure');
      }
      
  }

  async getLastAudit(auditTypeId,dealerId,isReschedule){
    const lastAudits = await this.afs.collection('audits',ref => ref.orderBy('creationDate','desc').where('type.id','==',auditTypeId).where('dealer.id','==',dealerId).limit(2)).snapshotChanges().pipe(
                      map(actions => actions.map(a => {
                        const data = a.payload.doc.data() as any;
                        const id = a.payload.doc.id;
                        return { id, ...data };
    }))).pipe(first()).toPromise();
    console.log("Last Audits********");
    console.log(lastAudits);
     let lastAudit:any;
     
     if(isReschedule && lastAudits[1]){
          lastAudit = lastAudits[1];
        }
        else if(lastAudits[0]){
         lastAudit = lastAudits[0];
        }

        console.log("LAst Audit");
        console.log(lastAudit);
        if(lastAudit && lastAudit.id){
          const auditSections = await this.afs.collection('audits').doc(lastAudit.id).collection('sections',ref => ref.orderBy('order')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    return data;
           }))).pipe(first()).toPromise();
           console.log(auditSections);

           lastAudit['sections'] = {};
           auditSections.forEach(section => {
             lastAudit['sections'][section.id] = section;
           })
        }
    if(lastAudit){
      this.events.publish('audit:lastAudit',lastAudit);
    }
    
  }

  inviteDealer(audit:any){

       this.http.post(CLOUD_FUNC_URL + 'inviteDealer',audit).subscribe((res: any) => {
                    console.log(res);
                    if (res.success) {
                       this.events.publish('audit:inviteDealerSuccess');
                    }
                    else{
                       this.events.publish('audit:inviteDealerFailure');
                    }

       }); 
  }

}



// WEBPACK FOOTER //
// ./src/providers/audit-schedule/audit-schedule.ts